import { FC } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { useIsDesktop } from '@/shared/hooks/use-is-desktop';

import { useModalsStore } from '../../modals.store';

import { FilePreview, FilePreviewProps } from './FilePreview';
// TODO file preview modal
export const FilePreviewModal: FC<FilePreviewProps> = (props) => {
  const isDesktop = useIsDesktop();
  const modals = useModalsStore();

  const handleRemove = () => {
    modals.closeModal();
    props.onRemove?.();
  };

  return (
    <StyledModal
      open={true}
      centered={isDesktop}
      footer={null}
      width={1340}
      height={isDesktop ? 800 : undefined}
      onCancel={modals.closeModal}
    >
      <FilePreview {...props} onRemove={props.onRemove ? handleRemove : undefined} />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      padding: 0;
      border-radius: 12px;
      overflow: hidden;
    }

    .ant-modal-body {
      height: 800px;
    }

    .ant-modal-close {
      background: ${COLORS.systemLight200};
      border-radius: 50%;
      top: 24px;
      right: 24px;
      width: 24px;
      height: 24px;
    }

    ${media.mobile} {
      top: 0;
      height: 100%;
      max-width: 100%;
      padding: 0;
      margin: 0;
      border-radius: 0;

      .ant-modal-content {
        border-radius: 0;
      }

      .ant-modal-close {
        display: none;
      }

      & > div,
      .ant-modal-body,
      .ant-modal-content {
        height: 100%;
      }
    }
  }
`;
